import {
  generateNotification,
  NotificationTypes,
  PopupComponent,
  TableComponent,
} from "deinestadtliebt-component-library";
import PriceItemEdit from "../priceitemedit/PriceItemEdit";
import { TicketPricingEditProps } from "./TicketPricingEdit.types";
import { useTranslation } from "react-i18next";
import { createEmptyPriceItem, PriceItem } from "../../utils/user/User.types";
import { useState } from "react";
import {
  generatePriceItemsTableRows,
  updateProviderCustomPriceDataForActivity,
} from "../../utils/user/UserUtils";
import { useAxios } from "../../utils/AxiosUtil";

export const TicketPricingEdit: React.FC<TicketPricingEditProps> = ({
  provider,
  setProvider,
  isLoading,
  toggleLoading,
  setUser,
}) => {
  const { t } = useTranslation();
  const axios = useAxios();

  const [keyPriceItemUpdate, setKeyPriceItemUpdate] = useState<number>(0);
  const [currentPriceItem, setCurrentPriceItem] = useState<PriceItem>(
    createEmptyPriceItem()
  );
  const [priceItemToUpdate, setPriceItemToUpdate] = useState<PriceItem>();

  /**
   * Helper to modify the content of the price for a provider
   * @param id if something has to be removed
   * @param type which code should be executed
   * @param item price item to update
   */
  const addCustomPriceItemForActivity = async (
    type: "create" | "delete" | "update",
    item: PriceItem,
    id: string
  ): Promise<void> => {
    toggleLoading(true);
    let localPrice: PriceItem[] = [...provider.customPriceItemsForActivity];
    switch (type) {
      case "create":
        localPrice.push(item!);
        break;
      case "delete":
        localPrice = localPrice.filter((item) => item.id !== id);
        break;
      case "update":
        let foundIndex: number = localPrice.findIndex(
          (item) => item.id === item?.id
        );
        if (foundIndex === -1) {
          toggleLoading(false);
          return;
        }
        localPrice[foundIndex] = item!;
        break;
    }
    const dataToUpdate = {
      ...provider,
      customPriceItemsForActivity: localPrice,
    };

    updateProviderCustomPriceDataForActivity(axios, dataToUpdate).then(
      (success) => {
        if (success) {
          setProvider(dataToUpdate);
          if (setUser) setUser(dataToUpdate);
          setCurrentPriceItem(createEmptyPriceItem());
          setPriceItemToUpdate(undefined);
          setKeyPriceItemUpdate(keyPriceItemUpdate + 1);
          generateNotification(
            NotificationTypes.SUCCESS,
            t(
              `notification.title.success.${
                !id ? "creationSuccessful" : "changesSuccessful"
              }`
            ),
            t(`notification.content.success.providerUpdate`)
          );
        } else
          generateNotification(
            NotificationTypes.ERROR,
            t(`notification.title.success.error`),
            t(`notification.content.success.deletion`)
          );
        toggleLoading(false);
      }
    );
  };

  return (
    <>
      <PriceItemEdit
        key={keyPriceItemUpdate}
        onSave={(item) => addCustomPriceItemForActivity("create", item, "")}
        priceItemToEdit={currentPriceItem}
        isLoading={isLoading}
      />
      <TableComponent
        header={t("providerConfigurationPage.tableHeaderPrice", {
          returnObjects: true,
        })}
        rows={generatePriceItemsTableRows(
          provider.customPriceItemsForActivity ?? [],
          addCustomPriceItemForActivity,
          setPriceItemToUpdate
        )}
        maxPageAmount={20}
      />
      <div className="popup-max-width">
        <PopupComponent
          open={!!priceItemToUpdate}
          toggleOpen={() => setPriceItemToUpdate(undefined)}
        >
          <h2>{t("providerEventsConfigurationPage.updateTitle")}</h2>
          <PriceItemEdit
            key={keyPriceItemUpdate}
            priceItemToEdit={priceItemToUpdate!}
            isLoading={isLoading}
            onSave={(priceItem) =>
              addCustomPriceItemForActivity("update", priceItem, "")
            }
          />
        </PopupComponent>
      </div>
    </>
  );
};
